/* Generated by scripts/apply-brand.js — do not edit by hand */
/** Every brand folder under brands/. */
export const BRAND_IDS = ["dentistryq","gpqbank","icmqs","mastersrh","medicineqs","ogqbank","ophthalmologyq","psychqs","solicitorqs","surgeryqs"] as const;
export type BrandId = (typeof BRAND_IDS)[number];

/** CRA inlines this at build time; falls back to brand.marketingUrl when unset. */
export const marketingUrlFromEnv: string | undefined = process.env.REACT_APP_MARKETING_URL_OPHTHALMOLOGYQ;

export const brand = {
  id: "ophthalmologyq",
  displayName: "OphthalmologyQ",
  appUrl: "https://app.ophthalmologyq.com",
  marketingUrl: "https://ophthalmologyq.com",
  contactEmail: "ophthalmologyq@gmail.com",
  metaDescription: "FRCOphth Part 1 & 2 banks covering every module and area—exam-style questions and timed mock exams. MSRA, interviews, coaching from leading UK ophthalmologists. Co-built by ophthalmologists, for ophthalmologists.",
  footerDescriptionHtml: "<strong>FRCOphth Part 1 &amp; Part 2</strong> question banks covering <strong>every module and every area</strong>—exam-style questions, timed mock exams, and UK-aligned explanations. Plus <strong>MSRA</strong>, <strong>Duke Elder</strong>, interview resources, and <strong>coaching from leading UK ophthalmologists</strong>. <strong>Co-built by ophthalmologists, for ophthalmologists.</strong>",
  signupKeyFeatures: ["Created by Ophthalmologist for Ophthalmologists","Extensive content with 1000s of questions overall","Covers Duke Elder Examination, FRCOphth Parts 1 & 2, & Refraction Exam","Regular updates to platform and questions"],
  s3Bucket: "app.ophthalmologyq.com",
  productIds: ["frcophth1","frcophth2","certlrs","ico_part_a","ico_part_b","ico_part_c","duke_elder","interview_coaching","portfolio_builder","interview_pack_st1","msra"],
  colors: {
    primary: "#0e4f99",
    primaryHover: "#0a3d75",
    navy: "#132242",
    navyDeep: "#0c1a30",
    navyMid: "#1a3358",
    accent: "#316aff",
    accentAlt: "#1b5ea6",
    stats: "#0c447c",
    statsHover: "#0a3560",
    footer: "#082e58",
    footerDeep: "#051525",
    footerLight: "#0a3d7a",
    footerMuted: "#041018",
  },
} as const;

export type Brand = typeof brand;
